import React, { useEffect, useRef, useState } from 'react';
import { useWindowDimensions } from '../../../../../common/utils/windowDimensions';
import css from './CategoryHeader.module.scss';
// import CategorySliderMobile from './components/CategorySliderMobile/CategorySliderMobile';
// import CategorySlider from './components/CategorySlider/CategorySlider';
// import { getMemoizedData } from '../../../../../common/utils/memo';
// import UserContext from '../../../../../common/utils/getContext';

const CategoryHeader = ({ category, subCategoriesData }) => {
    const [data, setData] = useState(subCategoriesData?.data);
    // const [nextLink, setNextLink] = useState(subCategoriesData?.links?.next);
    // const { userToken, lang, localization } = useContext(UserContext);
    useEffect(() => {
        setData(subCategoriesData?.data);
        // setNextLink(subCategoriesData?.links?.next);
    }, [subCategoriesData]);

    // const loadMore = useMemo(() => {
    //     if (nextLink) {
    //         return () => {
    //             getMemoizedData(nextLink, userToken, lang, false, localization?.currency).then((newData) => {
    //                 setData((pre) => [...pre, ...newData?.data]);
    //                 setNextLink(newData?.links?.next);
    //             });
    //         };
    //     }
    //     return nextLink;
    // }, [lang, localization?.currency, nextLink, userToken]);

    const [headerWidth, setHeaderWidth] = useState(0);
    const width = useWindowDimensions();
    const headerRef = useRef(null);
    useEffect(() => {
        if (headerRef.current) {
            setHeaderWidth(headerRef.current.offsetWidth);
        }

        return () => {};
    }, [width]);

    return (
        <div ref={headerRef} className={data?.length > 0 ? css.pb12 : ''}>
            <div
                className={css.storeTitleMain}
                style={{
                    paddingBottom: data?.length > 0 && headerWidth > 0 && width < 768 ? '7px' : 'px'
                }}
            >
                {category.data.name}
            </div>
            {/* {data?.length > 0 && headerWidth > 0 ? (
                width < 768 ? (
                    <CategorySliderMobile loadMore={loadMore} loadMoreCss={css.loadMore} headerWidth={headerWidth} data={data} />
                ) : (
                    <CategorySlider loadMore={loadMore} loadMoreCss={css.loadMore} headerWidth={headerWidth} data={data} />
                )
            ) : null} */}
        </div>
    );
};
export default CategoryHeader;
